import interpolateComponents from '@automattic/interpolate-components';

import { Box } from 'components/Box';
import { BodyMicro } from 'components/Text/BodyMicro';
import { Underline } from 'components/Text/Underline';

import { CreditCardBrandImage } from './CreditCardBrandImage';

type Props = {
  brand: string | undefined;
};

export function CreditCardCvcTooltip({ brand }: Props) {
  if (!brand)
    return (
      <>
        <BodyMicro lineHeight={1.25} textAlign="left">
          {interpolateComponents({
            mixedString: getText(
              'For Visa, MasterCard and Discover, the {{b}}3 digits{{/b}} on the {{u}}back{{/u}} of your card (left).',
            ),
            components: {
              b: <strong />,
              u: <Underline />,
            },
          })}
        </BodyMicro>

        <BodyMicro lineHeight={1.25} textAlign="left" mt="8px">
          {interpolateComponents({
            mixedString: getText(
              'For American Express, the {{b}}4 digits{{/b}} on the {{u}}front{{/u}} of your card (right).',
            ),
            components: {
              b: <strong />,
              u: <Underline />,
            },
          })}
        </BodyMicro>

        <Box display="flex" mx="-4px" mt={18}>
          <Box width={1 / 2} px="4px">
            <CreditCardBrandImage />
          </Box>
          <Box width={1 / 2} px="4px">
            <CreditCardBrandImage isAmex />
          </Box>
        </Box>
      </>
    );

  if (brand === 'amex')
    return (
      <>
        <BodyMicro lineHeight={1.25} mb={12}>
          {interpolateComponents({
            mixedString: getText(
              'The {{b}}4 digits{{/b}} on the {{u}}front{{/u}} of your card',
            ),
            components: {
              b: <strong />,
              u: <Underline />,
            },
          })}
        </BodyMicro>
        <CreditCardBrandImage isAmex />
      </>
    );

  return (
    <>
      <BodyMicro lineHeight={1.25} mb={12}>
        {interpolateComponents({
          mixedString: getText(
            'The {{b}}3 digits{{/b}} on the {{u}}back{{/u}} of your card',
          ),
          components: {
            b: <strong />,
            u: <Underline />,
          },
        })}
      </BodyMicro>
      <CreditCardBrandImage />
    </>
  );
}
